import styled from "styled-components";

export const Container = styled.div`
    text-align:center;
    align-items: center;
`;
export const Image = styled.div`
    align-items: center;
    text-align:center;
    > img{
        width: 30%;
    }
`;
export const Controller = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align:center;
`;